/* __next_internal_client_entry_do_not_use__ default auto */ import * as React from 'react';
import { createSvgIcon } from "../../utils/index.js";
/**
 * @ignore - internal component.
 */ import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');
